import { c as _c } from "react/compiler-runtime";
import Add from "@mui/icons-material/Add";
import { Box, IconButton } from "@mui/material";
import React from "react";
type AddArgumentButtonProps = {
  onClick: () => void;
  title: string;
};
export const AddArgumentButton: React.FC<AddArgumentButtonProps> = t0 => {
  const $ = _c(5);
  const {
    onClick,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      justifyContent: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Add />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick || $[3] !== title) {
    t3 = <Box sx={t1}><IconButton title={title} onClick={onClick}>{t2}</IconButton></Box>;
    $[2] = onClick;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};